













import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { OwnerDto, ClientSelector } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxOwner extends Vue {
  private types: OwnerDto[] | null = [];
  public selectedType = new OwnerDto();
  private contactId: number = 0;

  $refs!: {
    selection: HTMLSelectElement;
  };

  public created() {
    this.contactId = parseInt(this.$route.params.contactId);
    this.getAvailableTypes();
  }

  public typeSelected(type: OwnerDto) {
    switch (type.id) {
      case ClientSelector.Main:
        this.$emit("ownerSelected", ClientSelector.Main);
        break;
      case ClientSelector.Both:
        this.$emit("ownerSelected", ClientSelector.Both);
        break;
      case ClientSelector.Partner:
        this.$emit("ownerSelected", ClientSelector.Partner);
        break;
      case ClientSelector.PensionClientMain:
        this.$emit("ownerSelected", ClientSelector.PensionClientMain);
        break;
      case ClientSelector.PensionClientPartner:
        this.$emit("ownerSelected", ClientSelector.PensionClientPartner);
        break;
    }
    this.selectedType = type;
  }

  public setSelected(type: ClientSelector) {
    if (type) {
      if (this.types) {
        this.types.forEach(element => {
          if (element.id === type) {
            this.selectedType = element;
            return;
          }
        });
      }
    }
  }

  public getClientName(type: ClientSelector): string {
    let name: string = "";
    if (type) {
      if (this.types) {
        this.types.forEach(element => {
          if (element.id === type) {
            if (element.name) name = element.name;
          }
        });
      }
    }
    return name;
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public getSelectedName(): string | undefined {
    return this.selectedType.name;
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .owner_Index(this.contactId)
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }

  public reset() {
    this.$refs.selection.selectedIndex = -1;
  }
}
